// extracted by mini-css-extract-plugin
export default {"list":"IncidentList_list__h+jM-"};